import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { MemberService } from '@app/core/members/member.service';
import { SettingsService } from '@app/core/settings/settings.service';
import * as R from 'ramda';

@Injectable()
export class MissingPropertiesService {

  constructor(private memberService: MemberService,
              private settingsService: SettingsService) { }

  public getMissingPropertyNames(): Observable<string[]> {
    return combineLatest([
      this.getMemberPropertiesNames(),
      this.getRequiredPropertyNames(),
    ]).pipe(
      map(([properties, requiredPropertyNames]) =>
        requiredPropertyNames.filter(name => !properties.includes(name)),
      ),
    );
  }

  private getMemberPropertiesNames(): Observable<string[]> {
    return this.memberService.get()
      .pipe(
        filter(Boolean),
        map((member) => member.properties),
        distinctUntilChanged(R.equals),
        map(properties => properties ? Object.keys(properties) : []),
      );
  }

  private getRequiredPropertyNames(): Observable<string[]> {
    return this.settingsService.getSettingsOnce()
      .pipe(map(settings => settings.schema.required));
  }
}
